
import { createSlice } from '@reduxjs/toolkit';

export const singlePostSlice = createSlice({
    name: 'singlePost',
    initialState: {
        loading: true,
        post_data: {},
        error: false,
    },
    reducers: {
        SINGLE_POST_FETCH_START: (state) => {
            state.loading = true
        },
        SINGLE_POST_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            state.post_data = action.payload
        },
        SINGLE_POST_FETCH_ERROR: (state) => {
            state.error = true
        },
        SINGLE_POST_FETCH_COMMENT_ADDON: (state, action) => {
            state.loading = false
            if (state.post_data.id === action.payload.post_id) {
                state.post_data = {
                    ...state.post_data,
                    totalComments: (state.post_data.totalComments || 0) + 1,
                    last_comments: [...(state.post_data.last_comments || []), action.payload]
                }
            }
        },
        SINGLE_DELETE_COMMENT: (state, action) => {
            state.loading = false
            if (state.post_data.id === action.payload.post_id) {
                state.post_data = {
                    ...state.post_data,
                    totalComments: Math.max(0, (state.post_data.totalComments || 0) - 1),
                    last_comments: (state.post_data.last_comments || []).filter((com) => com.id !== action.payload.comment_id)
                }
            }
        },
        SINGLE_POST_ADD_REPLY: (state, action) => {
            if (state.post_data.id === action.payload.post_id) {
                state.post_data = {
                    ...state.post_data,
                    last_comments: (state.post_data.last_comments || []).map((comment) =>
                        comment.id === action.payload.comment_id
                            ? { ...comment, comment_reply: [...(comment.comment_reply || []), action.payload] }
                            : comment
                    )
                }
            }
        },
        SINGLE_POST_DELETE_REPLY: (state, action) => {
            if (state.post_data.id === action.payload.post_id) {
                state.post_data = {
                    ...state.post_data,
                    last_comments: (state.post_data.last_comments || []).map((com) =>
                        com.id === action.payload.comment_id
                            ? { ...com, comment_reply: (com.comment_reply || []).filter(reply => reply.id !== action.payload.comment_reply_id) }
                            : com
                    )
                }
            }
        },
        SINGLE_POST_LIKE_UPDATE: (state, action) => {
            if (state.post_data.id === action.payload.post_id) {
                state.post_data = { ...state.post_data, totalLikes: action.payload.likes_count, is_like: action.payload.is_like }
            }
        },
    }
});

export const { SINGLE_POST_DELETE_REPLY, SINGLE_POST_ADD_REPLY, SINGLE_DELETE_COMMENT, SINGLE_POST_FETCH_COMMENT_ADDON, SINGLE_POST_FETCH_START, SINGLE_POST_FETCH_SUCCESS, SINGLE_POST_FETCH_ERROR, SINGLE_POST_LIKE_UPDATE } = singlePostSlice.actions;
export default singlePostSlice.reducer;